import request from "@/utils/request";
var activity = '/activity'

export function getActivity(customId){
  return request({
    url:activity+'/v3/public/operation/config/find',
    method:'get',
    data:{customId}
  })
}

//查看用户是否已经报名
export function findUserOperation(data){
  return request({
    url:activity+'/v3/operation/user/log/query',
    method:'get',
    data
  })
}

//报名
export function application(data){
  console.log(data)
  return request({
    url:activity+'/v3/operation/user/log/add',
    method:'post',
    data,
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
  })
}

//交易所活动 公告/邮件报名
export function getNewActivity(customId){
  return request({
    url:activity+'/v3/public/operation/config/new-find',
    method:'get',
    data:{customId} 
  })
}


// WEBPACK FOOTER //
// ./src/view/contractCompetition/api.js